import { render, staticRenderFns } from "./dialogue.vue?vue&type=template&id=90ff5134&scoped=true"
import script from "./dialogue.vue?vue&type=script&lang=js"
export * from "./dialogue.vue?vue&type=script&lang=js"
import style0 from "./dialogue.vue?vue&type=style&index=0&id=90ff5134&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ff5134",
  null
  
)

export default component.exports